import EditionType from "types/EditionType";
import ContributionsList from "components/authors/ContributionsList";
import { BookSeriesTag } from "components/series/BookSeriesTag";
import BookMatchPercentage from "components/match/BookMatchPercentage/BookMatchPercentage";
import CoverLink from "components/Cover/CoverLink";
import TextLink from "hardcover-ui/components/TextLink";
import { ResizeableBookButton } from "features/BookButton";
import BookHighlights from "components/BookRow/BookHighlights";
import { LetterbooksSerializersBook } from "types/serializers";

interface Props {
  book: LetterbooksSerializersBook;
  edition?: EditionType;
  size: "sm" | "md" | "lg";
  className?: string;
  referrerUserId?: number;
  settings?: {
    showInfoClass?: string;
    linkContributions?: boolean;
  };
}

export default function LetterbooksBookRow({
  book,
  edition,
  size = "md",
  className = "",
  referrerUserId,
  settings = {
    showInfoClass: "",
    linkContributions: false,
  },
}: Props) {
  const coverSize = size === "lg" ? "md" : size === "md" ? "sm" : "xs";

  return (
    <div className={`${className} flex flex-row space-x-2 w-full`}>
      <div className="flex-none">
        <CoverLink
          book={book}
          edition={edition}
          size={coverSize}
          variant="secondary"
          settings={{
            tooltip: true,
            showStatus: true,
            details: true,
          }}
        />
      </div>
      <div className="grow">
        <p className="shrink space-x-2 flex items-baseline">
          <BookSeriesTag
            book={book}
            className="max-w-[14rem] sm:max-w-[30rem] overflow-hidden text-ellipsis"
          />
          <BookMatchPercentage bookId={book.id} />
        </p>
        <div>
          <TextLink
            href={`/books/${book.slug}`}
            variant="title"
            size="md"
            underline={false}
          >
            {edition ? edition.title : book.title}
          </TextLink>
          <ContributionsList
            contributions={book.contributions}
            link={settings.linkContributions || false}
            size="xs"
            primary
            byLine
          />
        </div>
        <div className="w-full flex flex-row justify-between items-end space-x-2 pr-2">
          <BookHighlights book={book} />
          <div className="flex-none">
            <ResizeableBookButton
              bookId={book.id}
              referrerUserId={referrerUserId}
              size="sm"
              sizeLg="md"
              sizeSm="sm"
              placement="bottom-end"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
